import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dynamic-turbo-frame"
export default class extends Controller {
  connect() {
    this.boundSetTurboFrame = this.setTurboFrame.bind(this);
    this.boundSetTurboFrame();
    window.addEventListener("resize", this.boundSetTurboFrame);
    this.viewer = document.querySelector("#viewer");
    if (this.viewer) {
      // It doesn't matter if we're not using #viewer – we can just ignore it.
      this.boundHandleClick = () => this.handleClick();
      this.element.addEventListener("click", this.boundHandleClick);
    }
  }

  disconnect() {
    window.removeEventListener("resize", this.boundSetTurboFrame);
    if (this.boundHandleClick) {
      this.element.removeEventListener("click", this.boundHandleClick);
    }
  }

  handleClick() {
    this.viewer.classList.remove("viewer-empty");
  }

  setTurboFrame() {
    if (document.body.offsetWidth < 768) {
      this.element.dataset.turboFrame = "_top";
    } else {
      // Defaults to viewer if nothing is set
      if (!this.element.dataset.turboFrame) {
        this.element.dataset.turboFrame = "viewer";
      }
    }
  }
}
